import React from 'react';
interface RangeSliderProps {
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  format: (value: number) => string;
}
export function RangeSlider({
  label,
  min,
  max,
  step,
  value,
  onChange,
  format
}: RangeSliderProps) {
  const pct = (value - min) / (max - min) * 100;
  return <div data-id="element-812" data-mp="2oke56ixpf8ip">
      <div className="mb-2 flex items-baseline justify-between" data-id="element-813" data-mp="2ok4eet4u4xby">
        <span className="text-[15px] font-bold" data-id="element-814" data-mp="2tgmhlokionm6">{label}</span>
        <span className="tabular text-[15px] font-bold text-brand-strong" data-id="element-815" data-mp="2xigcfg816xef">{format(value)}</span>
      </div>
      <div className="relative h-7" data-id="element-816" data-mp="32hsyvzuzq2gh">
        <div className="absolute inset-x-0 top-1/2 h-1.5 -translate-y-1/2 rounded-full bg-line" data-id="element-817" data-mp="32im0kmf3e1rr" />
        <div className="absolute left-0 top-1/2 h-1.5 -translate-y-1/2 rounded-full bg-brand" style={{
        width: `${pct}%`
      }} data-id="element-818" data-mp="37gnih40s7v1n" />
        <input type="range" className="range relative" min={min} max={max} step={step} value={value} aria-label={label} onChange={e => onChange(Number(e.target.value))} data-id="element-819" data-mp="1d2mgwbduktxv" />
      </div>
    </div>;
}